import React from 'react';
import { Alert } from 'react-bootstrap';
import { Trans, useTranslation } from "react-i18next";
import {Flag} from "semantic-ui-react";

const VolunteerApplicationPersonalDetails = (props) => {

  const { t } = useTranslation('volunteer-application');

  return (
    <div id='volunteer-application-approval-personal-details'>
      <div className={'row'}>
        <div className={'col-sm-6 mb-3'}>
          <div>{t('volunteer-application.form.firstName')}</div>
          <div><b>{props.values.firstName}</b></div>
        </div>
        <div className={'col-sm-6 mb-3'}>
          <div>{t('volunteer-application.form.lastName')}</div>
          <div><b>{props.values.lastName}</b></div>
        </div>
      </div>
      <div className={'row'}>
        <div className={'col-sm-6 mb-3'}>
          <div>{t('volunteer-application.form.city')}</div>
          <div><b>{props.values.city}</b></div>
        </div>
        <div className={'col-sm-6 mb-3'}>
          <div>{t('volunteer-application.form.country')}</div>
          <div><span><Flag name={props.values.country.toLowerCase()}/></span> USA</div>
        </div>
      </div>

      <div className={'row'}>
        <div className={'col-sm-6 mb-3'}>
          <div>{t('volunteer-application.form.presentation-style')}</div>
          <div>
            <div><span style={{paddingRight: '10px'}}><i className={"fas fa-" + (props.values.canPresentInPerson ? "check" : "times")}
                    style={{color: (props.values.canPresentInPerson ? "green" : "red")}}/></span>
                    {t('volunteer-application.form.presentation-style-in-person')}</div>
            <div><span style={{paddingRight: '10px'}}><i className={"fas fa-" + (props.values.canPresentOnline ? "check" : "times")}
                                                         style={{color: (props.values.canPresentOnline ? "green" : "red")}}/></span>
                    {t('volunteer-application.form.presentation-style-online')}</div>
          </div>
        </div>
      </div>

      <Alert variant="success">
        <Alert.Heading>{t('volunteer-application.notes.create-account.header')}</Alert.Heading>
        <p>
          <Trans t={t} i18nKey={'volunteer-application.notes.create-account.description'}
                 values={{ 'email': props.values.email }}>
            Ο χρήστης δεν έχει λογαριασμό κι ένας νέος λογαριασμός με δικαιώματα
            <b>χρήστη εθελοντή</b> θα δημιουργηθεί χρησιμοποιώντας το email <b>email</b>.
            Επίσης ένα εισαγωγικό email θα αποσταλεί στη διεύθυνση αυτή.
          </Trans>
        </p>
      </Alert>
    </div>
  )
}

export default VolunteerApplicationPersonalDetails;